import { defineStore } from 'pinia';
import { computed, ref, type Ref } from 'vue';
import { usePiniaRefStore } from '../composables/usePiniaRefStore';

/**
 * Collects loading flags from anywhere in the app (route transitions, queries,
 * mutations) into a single `isLoading` used by the global progress indicator.
 */
export const useLoadingStore = defineStore('loading', () => {
  const sources = ref<Ref<boolean>[]>([]);

  const isLoading = computed(() => sources.value.some((source) => source.value));

  const register = (source: Ref<boolean>) => {
    sources.value.push(source);

    return () => {
      const index = sources.value.indexOf(source);
      if (index >= 0) sources.value.splice(index, 1);
    };
  };

  return { isLoading, register };
});

export const useLoading = () => usePiniaRefStore(useLoadingStore());

/** Usable outside of a component scope (e.g. the router). */
export const registerLoading = (source: Ref<boolean>) => useLoadingStore().register(source);
